import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminHeader.css';

const AdminHeader = ({ onToggleMenu, isMenuOpen }) => {
  const navigate = useNavigate();

  return (
    <header className="admin-header">
      <div className="admin-header-content">
        {/* Menu toggle button */}
        <button 
          className={`menu-toggle ${isMenuOpen ? 'hidden' : ''}`}
          onClick={onToggleMenu}
          aria-label="Open menu"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path 
              d="M3 12h18M3 6h18M3 18h18" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
        </button>

        {/* Title */}
        <h1 className="admin-title">
          🚀 Administrador
        </h1>

        {/* Home button */}
        <button 
          className="home-button"
          onClick={() => navigate('/')}
        >
          <span className="home-icon">🏠</span>
          Ir al Inicio
        </button>
      </div>
    </header>
  );
};

export default AdminHeader;